// "Spot the Slip" expansion — DAILY ROUTINE theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_DAILY_ROUTINE = [
  ["Oggi sto molto occupato e non posso uscire.", "Oggi sono molto occupato e non posso uscire.", "essere-stare",
    "Being busy uses essere → sono occupato.", "essere-vs-stare"],
  ["La mattina sto stanco fino al caffè.", "La mattina sono stanco fino al caffè.", "essere-stare",
    "Tiredness uses essere → sono stanco.", "essere-vs-stare"],
  ["Il mio orario di lavoro è molto regolare.", "Il mio orario di lavoro è molto regolare.", "essere-stare",
    "Trap check: a defining feature uses essere. (Already correct!)", "essere-vs-stare"],
  ["Sto attento a non fare tardi.", "Sto attento a non fare tardi.", "essere-stare",
    "Trap check: 'stare attento' correctly uses stare. (Already correct!)", "essere-vs-stare"],
  ["Ho un routine molto rigida.", "Ho una routine molto rigida.", "gender",
    "Routine is feminine → una routine.", "gender-of-nouns"],
  ["La fine settimana resto a casa.", "Il fine settimana resto a casa.", "gender",
    "Fine settimana is masculine → il fine settimana.", "gender-of-nouns"],
  ["Seguo una ritmo molto tranquillo.", "Seguo un ritmo molto tranquillo.", "gender",
    "Ritmo is masculine → un ritmo.", "gender-of-nouns"],
  ["Mi piace le mattine tranquille.", "Mi piacciono le mattine tranquille.", "piacere",
    "Plural mornings liked → piacciono.", "piacere-and-similar-verbs"],
  ["Mi alzo a le sei ogni giorno.", "Mi alzo alle sei ogni giorno.", "articulated-prep",
    "a + le contracts to alle.", "preposition-contractions"],
  ["Esco di casa alle sette.", "Esco di casa alle sette.", "preposition",
    "Trap check: 'uscire di casa' is the fixed expression. (Already correct!)", "di-vs-da"],
  ["Quando ero studente, mi sono alzato sempre tardi.", "Quando ero studente, mi alzavo sempre tardi.", "passato-imperfetto",
    "A repeated past habit is imperfetto → mi alzavo.", "passato-prossimo-vs-imperfetto"],
  ["Stamattina mi ho svegliato presto.", "Stamattina mi sono svegliato presto.", "auxiliary",
    "Reflexive verbs take essere → mi sono svegliato.", "compound-tenses-and-auxiliaries"],
  ["Voglio che la mia routine è più sana.", "Voglio che la mia routine sia più sana.", "congiuntivo",
    "A wish about your routine (volere che) triggers the subjunctive → sia.", "congiuntivo-presente"],
  ["È necessario che tu dormi otto ore.", "È necessario che tu dorma otto ore.", "congiuntivo",
    "Impersonal 'è necessario che' takes the subjunctive → dorma.", "congiuntivo-presente"],
  ["Non faccio mai niente la domenica.", "Non faccio mai niente la domenica.", "negation",
    "Trap check: Italian uses double negation (non … mai … niente). (Already correct!)", "negation"],
];
